/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskScheduleRBase } from './ExecRiskScheduleRBase';
import {
    ExecRiskScheduleRBaseFromJSON,
    ExecRiskScheduleRBaseFromJSONTyped,
    ExecRiskScheduleRBaseToJSON,
} from './ExecRiskScheduleRBase';

/**
 * 
 * @export
 * @interface ExecRiskScheduleRDef
 */
export interface ExecRiskScheduleRDef {
    /**
     * 
     * @type {ExecRiskScheduleRBase}
     * @memberof ExecRiskScheduleRDef
     */
    base_form?: ExecRiskScheduleRBase;
}

/**
 * Check if a given object implements the ExecRiskScheduleRDef interface.
 */
export function instanceOfExecRiskScheduleRDef(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskScheduleRDefFromJSON(json: any): ExecRiskScheduleRDef {
    return ExecRiskScheduleRDefFromJSONTyped(json, false);
}

export function ExecRiskScheduleRDefFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskScheduleRDef {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'base_form': !exists(json, 'base_form') ? undefined : ExecRiskScheduleRBaseFromJSON(json['base_form']),
    };
}

export function ExecRiskScheduleRDefToJSON(value?: ExecRiskScheduleRDef | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'base_form': ExecRiskScheduleRBaseToJSON(value.base_form),
    };
}

